export const SIZE_UNITS = { IN: "in", CM: "cm" }

const CM_PER_INCH = 2.54

// Rounding is presentation-only: every call converts from the stored inches.
const formatters = {
  [SIZE_UNITS.IN]: (inches) => `${inches.toFixed(2)}"`,
  [SIZE_UNITS.CM]: (inches) =>
    `${parseFloat((inches * CM_PER_INCH).toFixed(1))} cm`,
}

export const formatArtworkSize = (width, height, unit = SIZE_UNITS.IN) => {
  const format = formatters[unit] || formatters[SIZE_UNITS.IN]
  const h = parseFloat(height) ? `${format(parseFloat(height))} H` : ``
  const w = parseFloat(width) ? `${format(parseFloat(width))} W` : ``
  return [h, w].filter(Boolean).join(` x `)
}
